import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// Read token and role fresh on every request so headers stay in sync with
// localStorage after login (when `/user-details/` sets the userRole).
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role");

  config.headers.Authorization = `Token ${JSON.parse(
    token === "undefined" || !token ? JSON.stringify("") : token,
  )}`;

  if (userRole) {
    config.headers["x-gridkey-user-role"] = userRole;
  }

  return config;
});

export default axiosInstance;
